import { render, staticRenderFns } from "./FornecedorList.vue?vue&type=template&id=935e2b72&scoped=true&"
import script from "./FornecedorList.vue?vue&type=script&lang=js&"
export * from "./FornecedorList.vue?vue&type=script&lang=js&"
import style0 from "./FornecedorList.vue?vue&type=style&index=0&id=935e2b72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935e2b72",
  null
  
)

export default component.exports